import { cn } from '@/shared/lib/utils'

/** 目录 / 创作中心列表卡片外框：黄色描边，hover 边框加粗 */
export const catalogListCardLinkClass = (...extra: Array<string | false | null | undefined>) =>
  cn(
    'relative flex h-full flex-col overflow-hidden rounded-lg bg-card shadow-sm ring-1 ring-amber-400/50 transition duration-200 hover:-translate-y-0.5 hover:bg-muted/50 hover:shadow-[0_12px_40px_-16px_rgba(245,158,11,0.28)] hover:ring-2 hover:ring-amber-400',
    ...extra,
  )

/** 正文区随内容撑开（封面自适应后不再锁死正文比例） */
export const CATALOG_LIST_CARD_BODY_CLASS =
  'flex min-h-0 flex-1 flex-col justify-between gap-1.5 px-3 py-2'

export const CATALOG_LIST_CARD_TITLE_CLASS =
  'line-clamp-1 text-[13px] font-semibold leading-tight text-zinc-100 group-hover:text-white'

export const CATALOG_LIST_CARD_SUMMARY_CLASS = 'line-clamp-1 text-[11px] leading-snug text-zinc-500'

export const CATALOG_LIST_CARD_META_ROW_CLASS =
  'flex min-w-0 flex-1 flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[10px] leading-none text-zinc-400 [&>span+span]:before:mr-1.5 [&>span+span]:before:text-zinc-600 [&>span+span]:before:content-["·"]'

export const CATALOG_LIST_CARD_BOTTOM_ROW_CLASS =
  'mt-auto flex items-end justify-between gap-2 pt-1'

export const CATALOG_LIST_CARD_CTA_CLASS =
  'inline-flex shrink-0 items-center gap-0.5 text-[10px] font-medium text-amber-400/90 transition group-hover:text-amber-300'

/** @deprecated 请用 CatalogListCardContent 底栏 */
export const CATALOG_LIST_CARD_FOOTER_CLASS =
  'mt-auto flex items-center justify-between gap-2 pt-1 text-[10px] font-medium text-amber-400/90'
